import React from 'react';

// Jumps to a section's online edit page in a new tab (so the analysis stays put). The href is
// pre-built by the parent (which knows the lesson + program context) via Routes.edit_admin_section_path.
const SectionEditLink = ({ href }: { href: string }) => (
  <a
    aria-label="Edit this section (opens in a new tab)"
    className="tw-whitespace-nowrap tw-text-sm tw-font-bold tw-text-spa-accent-text tw-no-underline
      hover:tw-text-spa-accent-text-hover hover:tw-underline"
    href={href}
    rel="noopener noreferrer"
    target="_blank"
  >
    Edit section
  </a>
);

export default SectionEditLink;
